import React from 'react';
import { styled } from '@volkswagen-onehub/components-core';
import { 
  Text, 
  TextAppearance, 
  TextColor,
  BreakpointWrapper,
  Breakpoints
} from '@volkswagen-onehub/components-core';

const Div = styled.div`
  width: 100%;
  height: var(--100vh);
  background-color: #000000;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 var(--size-grid002);
  overflow-x: hidden;

  @media screen and (min-width: 960px) {
    padding: 0 var(--size-grid001);
  }
  @media screen and (min-width: 1280px) {
    padding: 0 var(--size-grid002);
  }
`;

const MaxWidthTextWrapper = styled.div`
  z-index: 2;
  width: 100%;
  max-width: 1920px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (min-width: 960px) {
    justify-content: flex-end;
  }
`;

const TextWrapper = styled.div`
  color: #ffffff;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: left;

  @media screen and (min-width: 560px) {
    width: 75%;
  }
  @media screen and (min-width: 960px) {
    width: 50%;
  }
  @media screen and (min-width: 1280px) {
    gap: 32px;
  }
  @media screen and (min-width: 1600px) {
    gap: 52px;
  }
`;

const Video = styled.video`
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  z-index: 0;
  top: 0;
  right: 0;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  z-index: 0;
  top: 0;
  right: 0;
`;


const videoURL = 'https://cdn.volkswagen.es/repository/app/vw-oneform/assets/videos/taigo.mp4';

export function SecondSlide() {
  return (
    <Div>
      <BreakpointWrapper max={Breakpoints.b560}>
        <Img src='https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/seccion2-taigo.png'/>
      </BreakpointWrapper>
      <BreakpointWrapper min={Breakpoints.b560}>
        <Video id="background-video" autoPlay loop muted data-keepplaying playsinline>
          <source src={videoURL} type="video/mp4" />
        </Video>
      </BreakpointWrapper>
      
      <MaxWidthTextWrapper>
        <TextWrapper className='second-slide-copies'>
          <Title/>
          <Body/>
        </TextWrapper>
      </MaxWidthTextWrapper>
    </Div>
  );
}

const Title = () => {
  return (
    <>
      <BreakpointWrapper max={Breakpoints.b560} >
        <Text appearance={TextAppearance.headline0450} color={TextColor.inherit} >
          ¿Por qué elegir una cosa{' '}<Text bold>si puedes tenerlo todo?</Text> 
        </Text>
      </BreakpointWrapper>
    
      <BreakpointWrapper min={Breakpoints.b560} max={Breakpoints.b1280}>
        <Text appearance={TextAppearance.headline0400} color={TextColor.inherit}>
          ¿Por qué elegir una cosa{' '}<Text bold>si puedes tenerlo todo?</Text>        
        </Text>
      </BreakpointWrapper>
      <BreakpointWrapper min={Breakpoints.b1280} max={Breakpoints.b1920}>
        <Text appearance={TextAppearance.headline0450} color={TextColor.inherit}>
          ¿Por qué elegir una cosa{' '}<Text bold>si puedes tenerlo todo?</Text>
        </Text>
      </BreakpointWrapper>
      <BreakpointWrapper min={Breakpoints.b1920}>
        <Text appearance={TextAppearance.headline0500} color={TextColor.inherit}>
          ¿Por qué elegir una cosa{' '}<Text bold>si puedes tenerlo todo?</Text>
        </Text>
      </BreakpointWrapper>  
    </>
  );
};

const Body = () => {
  return (
    <>
      <BreakpointWrapper max={Breakpoints.b1280}>
        <Text appearance={TextAppearance.headline0300} color={TextColor.inherit}>
          Escápate para descubrir <Text bold>cómo se fabrica el nuevo Taigo</Text>, disfruta de una estancia inolvidable en Pamplona para dos personas y elige cómo quieres vivir esa experiencia.
        </Text>
      </BreakpointWrapper>
      <BreakpointWrapper min={Breakpoints.b1280} max={Breakpoints.b1600}>
        <Text appearance={TextAppearance.headline0350} color={TextColor.inherit}>
        Escápate para descubrir <Text bold>cómo se fabrica el nuevo Taigo</Text>, disfruta de una estancia inolvidable en Pamplona para dos personas y elige cómo quieres vivir esa experiencia.
        </Text>
      </BreakpointWrapper>
      <BreakpointWrapper min={Breakpoints.b1600} max={Breakpoints.b1920}>
        <Text appearance={TextAppearance.headline0300} color={TextColor.inherit}>
        Escápate para descubrir <Text bold>cómo se fabrica el nuevo Taigo</Text>, disfruta de una estancia inolvidable en Pamplona para dos personas y elige cómo quieres vivir esa experiencia.
        </Text>
      </BreakpointWrapper>
      <BreakpointWrapper min={Breakpoints.b1920} >
        <Text appearance={TextAppearance.headline0350} color={TextColor.inherit}>
        Escápate para descubrir <Text bold>cómo se fabrica el nuevo Taigo</Text>, disfruta de una estancia inolvidable en Pamplona para dos personas y elige cómo quieres vivir esa experiencia.
        </Text>
      </BreakpointWrapper>  
    </>
  );
};
